import { forwardRef, Ref, SVGProps } from 'react';
import { Chips as ChipsPR, ChipsProps } from 'primereact/chips';
import { CloseIcon } from './icons';

export const Chips = forwardRef((props: ChipsProps, ref?: Ref<ChipsPR>) => {
  return (
    <ChipsPR
      ref={ref}
      {...props}
      removeIcon={props.removeIcon || ((options) => <CloseIcon {...(options.iconProps as SVGProps<SVGSVGElement>)} />)}
    />
  );
});

export type { ChipsProps };
